import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col, InputGroup, FormControl, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Pagination from '../../components/common/Pagination';
import { eventsFetch } from '../../actions';
import EventsListItem from './EventsListItem/EventsListItem';
import LoadingOverlay from '../common/LoadingOverlay';
import handleClientSideSearch from '../../utils/handleClientSideSearch';
import moment from 'moment';

import usePagination from '../../hooks/usePagination';

function EventsList(props) {
	const { /* upcoming, */ /* partnerID, */ limit, dashboard } = props;
	const user = useSelector(({ user }) => user);
	const { userID } = user;
	const { events, eventsLoading } = useSelector(state => state.event);
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [search, setSearch] = useState(null);
	let filteredEvents = [...events]; /* .filter((e) => {
		let returnEvent = false;

		e.partners.forEach((p) => {
			if (p.partnerID === partnerID) {
				returnEvent = true;
			}
		});

		return returnEvent;
	}); */
	filteredEvents = filteredEvents.sort((a, b) => {
		return moment(b.eventStarts).unix() - moment(a.eventStarts).unix();
	});

	useEffect(() => {
		if (userID) {
			dispatch(eventsFetch(userID));
		}
	}, [dispatch, userID]);

	if (search) {
		filteredEvents = handleClientSideSearch(filteredEvents, search);
	}

	const {
		setPage,
		pageCount,
		currentPage,
		currentData,
	} = usePagination(filteredEvents, limit);

	const currentEvents = currentData();

	const paginate = ({ selected }) => setPage(selected + 1);
	const handleSearch = ({ target }) => setSearch(target.value || null);

	return (
		<Card style={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
			<Row>
				<Col md={4}>
					<h3>{t('events.header')}</h3>
				</Col>
				<Col md={{
					span: dashboard ? 4 : 4,
					offset: dashboard ? 4 : 4
				}}>
					<div style={{ float: 'right' }}>
						<InputGroup>
							<InputGroup.Prepend>
								<InputGroup.Text className="input-addon">
									{filteredEvents.length} {t('general.results')}
								</InputGroup.Text>
							</InputGroup.Prepend>
							<FormControl
								placeholder={t('general.search')}
								onChange={handleSearch}
							/>
						</InputGroup>
					</div>
				</Col>
			</Row>

			{!eventsLoading && events ?
				<>
					{currentEvents.map(event => (
						<EventsListItem
							event={event}
							user={user}
							key={event.eventID}
						/>
					))}

					{filteredEvents.length ?
						<Card.Footer style={{ backgroundColor: '#ffffff' }}>
							<div className="pull-right">
								<Pagination
									forcePage={currentPage}
									pageCount={pageCount}
									marginPagesDisplayed={2}
									pageRangeDisplayed={5}
									onPageChange={paginate}
								/>
							</div>
						</Card.Footer>
					: null}
				</>
				:
				<LoadingOverlay variant="dark" />
			}

			{!eventsLoading && currentEvents.length < 1 ?
				<Card.Body style={{ backgroundColor: '#ffffff' }}>
					<p>{t('events.no_events')}</p>
				</Card.Body>
			: null}
		</Card>
	)
}

EventsList.propTypes = {
	upcoming: PropTypes.bool,
	limit: PropTypes.number
}


export default EventsList;